import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { setContactFormData, clearContactFormData } from '../../store/actions/contactForm';
import { saveContact } from '../../store/actions/contacts';
import { ICONS, USER_TYPES, GOOGLE_API_KEY, USER_ROLES } from '../../common/constants';
import { selectContactFormData } from '../../store/selectors/contactForm';

import Button from '../Button/Button';
import Col from '../Col';
import File from '../File';
import Form, { Heading } from '../Form';
import IcoMoon from '../IcoMoon';
import Input from '../Input';
import Row from '../Row';
import Tile from '../Tile';
import { selectContacts, selectHomeOwners } from '../../store/selectors/contacts';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Toggle from '../Toggle';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import { stopFormLoading } from '../../store/actions/loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import variables from '../../styles/includes/variables.scss';
import CheckBox from '../Checkbox';
import { selectSuiteUsers } from '../../store/selectors/suiteUsers';
import { selectSuiteById } from '../../store/selectors/suites';
import * as client from '../../services/client';
import Select from '../Select';

import { variables } from '../../Tenants';
import { onCheckDocument } from '../../helpers/CommonHelpers';


const validEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

class AddSuiteUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonPressed: '',
      errors: {},
      matchedEmails: [],
      location: '',
      predictions: [],
      formType: 'New'
    }
  }
  componentDidMount() {
    const { onStopFormLoading, contactFormData, setContactFormData, suite } = this.props;
    onStopFormLoading();
    if (contactFormData.id) {
      let userRole = contactFormData.roles[0].role.name;
      setContactFormData({ userRole })
    } else {
      setContactFormData({
        userRole: 'Home Owner',
        userSuites: [{ Id: suite.id, PropertyId: suite.propertyId }]
      })
    }
  }

  validateContactFormData(actionType) {
    this.setState({ buttonPressed: actionType })
    let { contactFormData } = this.props;
    if(contactFormData.formType === 'New'){
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    // var name = /^[a-zA-Z"'\s-]*$/
    //Modified By: Anjali
    //Modified On: 12-08-2023
    //Jira-Id: https://bosframework.atlassian.net/browse/JUN-3939
    //Reason: UI-Allow for letters, numbers and special characters when adding a name for a contact

    var name = /^[a-zA-Z0-9\u00C0-\u017F-',. &*]*$/
    let errors = {};

    if (contactFormData.firstname.trim().length === 0) {
      errors.firstname = 'Please enter  the first name !'
      errors.errors = true
    } else {
      if (!contactFormData.firstname.match(name)) {
        // errors.firstname = 'Alphabets from [A-Z , a-z] are only allowed!'
        errors.firstname = "Please use only letters, numbers, spaces, and the following characters: , . & *'"
        errors.errors = true
      }
    }
    if (contactFormData.lastname.trim().length === 0) {
      errors.lastname = 'Please enter the last name !'
      errors.errors = true
    }
    if (contactFormData.email.trim().length === 0) {
      errors.email = 'Please enter the  email address !'
      errors.errors = true
    }
    if (!validEmailRegex.test(contactFormData.email.toLowerCase())) {
      errors.email = 'Please enter the email address !'
      errors.errors = true
    }
    if (contactFormData.phone.length < 10) {
      errors.phone = 'Please Enter a 10 digit Phone Number'
      errors.errors = true
    }
    if (contactFormData.phone.length > 20) {
      errors.phone = 'Phone Number can not be more than 20 digits'
      errors.errors = true
    }
    // else if (!contactFormData.phone.match(phoneno)) {
    //   errors.phone = 'Please Enter a 10 digit Phone Number'
    //   errors.errors = true
    // }

    // if (!contactFormData.id) {
    let contacts = [...this.props.contacts, ...this.props.allContacts];
    //   if(!contactFormData.old){
    //  for(var i = 0; i < contacts.length; i++) {
    //  if (contacts[i].email === contactFormData.email.trim()) {
    //     errors.email = 'This contact already exists.'
    //     errors.errors = true
    //     toast.error(' 🚫 This contact already exists !', { autoClose: 12000, position: 'top-center' })

    //   }
    // }}
    // }


    if (contactFormData.id && contactFormData.old === false) {
      const { suiteUsers } = this.props;
      for (var j = 0; j < suiteUsers.length; j++) {
        if (suiteUsers[j].email === contactFormData.email) {
          // errors.email = 'This contact already exists.'
          errors.errors = true
          toast.error(` 🚫 This contact already exists for this ${variables.suite} !`, { autoClose: 12000, position: 'top-center' })

        }
      }
    }



    this.setState({
      errors: errors
    })
    if (errors.errors) {

    } else {
      // if(contactFormData.old === false && contactFormData.id){
      //   const { user,suite } = this.props;
      //   let params = {
      //     "SuiteId": suite.id,
      //     "UserId": contactFormData.id,
      //     "Role": contactFormData.roles[0].role.name,
      //     "CreatedBy": user.id,
      //     "IsPrimaryContact":contactFormData && contactFormData.isPrimaryContact && contactFormData.isPrimaryContact === true ? true : false,
      //     "PropertyId": suite.propertyId
      //   }
      //   this.props.onAddingExistingUser(params)
      // }else{        
      this.props.onSubmit(contactFormData, actionType);
      //}

    }
  } else {
    this.props.onSubmit(contactFormData, actionType);
  }
  }

  componentDidUpdate() {
    const { validation, onClose, clearValidation, clearContactFormData, suite, setContactFormData } = this.props;
    if (validation.status === true) {
      if (validation.message === 'Contact' && this.state.buttonPressed === 'saveContact') {
        onClose();
        clearContactFormData();
        clearValidation();
      } else if (validation.message === 'Contact' && this.state.buttonPressed === 'saveAndAdd') {
        clearContactFormData();
        clearValidation();
        setContactFormData({
          userRole: 'Home Owner',
          formType: this.state.formType,
          userSuites: [{ Id: suite.id, PropertyId: suite.propertyId }]
        })
      }
    }
  }

  getLocation = async (value) => {
    this.setState({ location: value })
    client.getLocations(value).then(response => {
      if (response.status === 200) {
        response.json().then(responseJson => {
          let data = JSON.parse(responseJson)
          this.setState({ predictions: data.predictions })
        })
      } else {
        //  alert("Can't find address");
        this.setState({ predictions: [] })
      }
    })
  }
  onClickLocation = async (address) => {
    const { onSetContactFormData } = this.props;
    const apiurl = `https://maps.google.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&address=${address}`;

    try {
      const result = await fetch(apiurl);
      const json = await result.json();
      let latitude = json.results[0].geometry.location.lat;
      let longitude = json.results[0].geometry.location.lng;
      const apiurl1 = `https://maps.google.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&latlng=${latitude},${longitude}`;

      const getResult = await fetch(apiurl1);
      const addressObj = await getResult.json();

      let addressLine1;
      let city;
      let state;
      let pincode;
      let addressData = addressObj.results[0].address_components;

      if (addressData && addressData.length > 0) {
        addressData.forEach(data => {
          if (data.types.indexOf('street_number') != -1) {
            addressLine1 = data.long_name
          }
          if (data.types.indexOf('route') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          if (data.types.indexOf('neighborhood') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          if (data.types.indexOf('sublocality_level_2') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          if (data.types.indexOf('sublocality_level_1') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          // if(!addressLine1) {
          //   if (data.types.indexOf('point_of_interest') != -1) {
          //     addressLine1 = data.long_name
          //   }
          // }
          if (data.types.indexOf('locality') != -1) {
            city = data.long_name
          }
          if (data.types.indexOf('administrative_area_level_1') != -1) {
            state = data.long_name
          }
          if (data.types.indexOf('postal_code') != -1) {
            pincode = data.long_name
          }
        });
        onSetContactFormData({ address: { addressLine1: addressLine1, city: city, province: state, postalCode: pincode } })
        this.setState({ predictions: [], location: '' })
      } else {
        // alert("Can't find address");
      }
    } catch (err) {
      // alert("Can't find address");
    }
  }

  enableButton() {
    const { firstname, lastname, email, phone, userRole, formType, selectedUserId } = this.props.contactFormData;

    let disabled = true
    if( formType === 'New'){
      disabled = !firstname || !lastname || !email || !phone || !userRole
      return disabled
    } else {
      disabled = !selectedUserId
      return disabled
    }
  }

  onErrorEmpty = (value) => {
    let errors = this.state.errors;
    errors[value] = '';
    this.setState({ errors })
  }

  contactType(role) {
    return role === "Home Owner" ? variables.homeOwner : role
  }

  onSelectUser = (e) => {
    const {onSetContactFormData, contacts } = this.props;
    onSetContactFormData({ selectedUserId: e.target.value })
    let contactObj = contacts.filter(ct => ct.id === e.target.value)[0];
    let role = contactObj.roles && contactObj.roles.length > 0 && contactObj.roles[0].role ? contactObj.roles[0].role.name : ''
    onSetContactFormData({ role: role })

  }
  render() {
    const { user, contactFormData, onClose, onSetContactFormData, sendResetPasswordLinkToUser, sendActivationLinkToUser, loader, suite, contacts } = this.props;
    let address = contactFormData.address != null ? contactFormData.address : {};
    let types = USER_TYPES.filter(u => (u === 'Home Owner' || u === 'Occupant' || u === 'Realtor'));
    let options = ['New', "Existing"];

    return (
      <Form
        headline={(contactFormData.old ? 'Edit' : 'Add a') + ' Person'}
        onClose={onClose}
        actions={(
          <>
            {loader ? <Loader center={true} /> : null}
            {contactFormData.old ? (contactFormData.status && contactFormData.status !== 'Active') ?
              <Button
                color="teal"
                size="small"
                label="Send Activation Link"
                disabled={this.enableButton()}
                onClick={() => sendActivationLinkToUser(contactFormData)}
              /> :
              <Button
                color="teal"
                size="small"
                label="Send Reset Password Link"
                disabled={this.enableButton()}
                onClick={() => sendResetPasswordLinkToUser(contactFormData)}
              />
              : <Button
                color="semantic"
                size="small"
                label="Save and Add Another"
                disabled={this.enableButton()}
                onClick={() => this.validateContactFormData('saveAndAdd')}
              />
            }
            <Button
              color="teal"
              size="small"
              label="Save Person"
              disabled={this.enableButton()}
              onClick={() => this.validateContactFormData('saveContact')}
            />
          </>
        )}
        component={(
          <>
            <Row chonky>
              <Col
                chonky
                xs="12"
                md="6"
              >
                <Heading>Contact Information</Heading>

                <Row mdCenter>
                  {contactFormData.id ?
                    null
                    :
                    options.map(type =>
                      <>
                        <div style={{ padding: '0.5rem', flexDirection: 'row' }}>
                          <Tile
                            onClick={e => {onSetContactFormData({ formType: type });this.setState({ formType: type})}}
                            active={type === contactFormData.formType}
                            title={type}
                            size="veryTiny"
                          />
                        </div>
                      </>
                    )
                  }
                </Row>
                {contactFormData && contactFormData.formType === 'New' ? <>
                  <Row>
                    <Col
                      xs="12"
                      md="6"
                    >
                      <Input
                        value={contactFormData.firstname}
                        onChange={e => onSetContactFormData({ firstname: e.target.value })}
                        label="First Name"
                        placeholder="First Name"
                        block
                        required
                        errors={this.state.errors.firstname}
                      />
                    </Col>
                    <Col
                      xs="12"
                      md="6"
                    >
                      <Input
                        value={contactFormData.lastname}
                        onChange={e => onSetContactFormData({ lastname: e.target.value })}
                        label="Last Name"
                        placeholder="Last Name"
                        block
                        required
                        errors={this.state.errors.lastname}
                      />
                    </Col>
                  </Row>
                  <Input
                    value={contactFormData.email}
                    onChange={e => {
                      this.onErrorEmpty('email')
                      return (
                        onSetContactFormData({ email: e.target.value })
                      )
                    }
                    }
                    label="Email"
                    placeholder="Email"
                    block
                    required
                    errors={this.state.errors.email}
                    disabled={(user.roles[0].role.name === 'Admin' || user.roles[0].role.name === 'Super Admin' || user.roles[0].role.name === 'Property Developer' || user.roles[0].role.name === 'Home Owner')?contactFormData.hasOwnProperty('isSpark') ? contactFormData.isSpark : false:false}                  
                  />
                  <CheckBox
                    value={(contactFormData.sendActivationEmail && contactFormData.sendActivationEmail === true) || (contactFormData.status && contactFormData.status === 'Invited') || (contactFormData.status && contactFormData.status === 'Active') || (contactFormData.lastLoggedOn && contactFormData.lastLoggedOn !== null)}
                    label='Send Activation Email'
                    onChange={() => onSetContactFormData({ sendActivationEmail: contactFormData.sendActivationEmail && contactFormData.sendActivationEmail === true ? false : true })}
                  />
                  <Input
                    value={contactFormData.phone}
                    onChange={e => {
                      this.onErrorEmpty('phone')
                      return (
                        onSetContactFormData({ phone: e.target.value })
                      )
                    }
                    }
                    label="Phone Number"
                    placeholder="Phone Number"
                    block
                    required
                    errors={this.state.errors.phone}
                  />

                  <Input
                    value={this.state.location}
                    onChange={e => this.getLocation(e.target.value)}
                    label="Search Location"
                    block
                    placeholder="Search Location"
                  />
                  {this.state.predictions.map((item, i) => {
                    return (
                      <div className='location_search' onClick={() => this.onClickLocation(item.description)}>{item.description}</div>
                    )
                  })}

                  <Input
                    value={address.hasOwnProperty('addressLine1') ? address.addressLine1 : ''}
                    onChange={e => onSetContactFormData({ address: { ...address, addressLine1: e.target.value } })}
                    label="Address"
                    // required
                    placeholder="eg., 123 Example Street"
                    block
                  // errors = {this.state.errors.address}
                  />
                  <Row>
                    <Col
                      xs="12"
                      md="4"
                    >
                      <Input
                        value={address.hasOwnProperty('city') ? address.city : ''}
                        onChange={e => onSetContactFormData({ address: { ...address, city: e.target.value } })}
                        label="City"
                        // required
                        placeholder="eg., Vancouver"
                        block
                      // errors = {this.state.errors.city}
                      />
                    </Col>
                    <Col
                      xs="12"
                      md="4"
                    >
                      <Input
                        value={address.hasOwnProperty('province') ? address.province : ""}
                        onChange={e => onSetContactFormData({ address: { ...address, province: e.target.value } })}
                        label="Province"
                        // required
                        placeholder="eg., BC"
                        block
                      // errors = {this.state.errors.province}
                      />
                    </Col>
                    <Col
                      xs="12"
                      md="4"
                    >
                      <Input
                        value={address.hasOwnProperty('postalCode') ? address.postalCode : ""}
                        onChange={e => {
                          this.onErrorEmpty('postalCode')
                          return (
                            onSetContactFormData({ address: { ...address, postalCode: e.target.value } })
                          )
                        }
                        }
                        label="Postal Code"
                        // required
                        placeholder="eg., A0A 0A0"
                        block
                      // errors = {this.state.errors.postalCode}
                      />
                    </Col>
                  </Row>

                  <File
                    label="Profile Picture"
                    onSelect={(file) => onCheckDocument(file) && onSetContactFormData({ selectedImage: file })}
                    files={contactFormData.selectedImage ? contactFormData.selectedImage : []}
                    image={contactFormData.profileImage}
                    errors={this.state.errors.profileImage}
                    type='image'
                  />
                </>
                  :
                  <>
                    <Select
                      value={contactFormData.hasOwnProperty('selectedUserId') ? contactFormData.selectedUserId : ''}
                      onChange={e => this.onSelectUser(e)}
                      options={contacts.map(propertyManager => ({ value: propertyManager.id, label: `${propertyManager.firstname} ${propertyManager.lastname}` }))}
                      label="Homeowner"
                      placeholder="(Select Homeowner)"
                      block
                    />
                  </>
                }
                </Col>
                <Col
                  chonky
                  xs="12"
                  md="6"
                >
                  {contactFormData && contactFormData.formType === 'New' ? <>

                    <div className="input__errors">
                      <div className="input__error">{this.state.errors.userRole}</div>
                    </div>
                    <Heading>Role</Heading>
                    <div style={{pointerEvents: contactFormData?.id && 'none'}}>
                    <Row granola>
                      {types.map(userType => (
                        <Col
                          granola
                          key={userType}
                          xs="6"
                          md="4"
                        >
                          <Tile
                            title={userType === 'Home Owner' ? variables.homeOwner : userType}
                            size="small"
                            active={userType === contactFormData.userRole}
                            onClick={() => userType === contactFormData.userRole ? null : onSetContactFormData({ userRole: userType, isPrimaryContact: false, Suites: userType === 'Home Owner' ? [{ Id: suite.id, PropertyId: suite.propertyId }] : [] })}
                            icon={(
                              <IcoMoon glyph={ICONS[userType]} />
                            )}
                          />
                        </Col>
                      ))}
                    </Row>
                    </div>
                  </>
                    : null}
                  <br />

                  <div style={{ marginTop: 10 }}>
                    {
                      contactFormData.userRole !== 'Realtor' && <Toggle
                      label={"Make " + this.contactType(contactFormData.userRole) + " the primary contact for the " + variables.suite + "?"}
                      value={contactFormData.isPrimaryContact}
                      onToggle={value =>
                        onSetContactFormData({ isPrimaryContact: !contactFormData.isPrimaryContact })
                      }
                    />
                    }
                  </div>
                  {contactFormData?.userRole?.toUpperCase() === USER_ROLES.OCCUPANT.toUpperCase() || contactFormData?.userRole?.toUpperCase() === USER_ROLES.HOME_OWNER.toUpperCase() || contactFormData?.userRole?.toUpperCase() === USER_ROLES.REALTOR.toUpperCase() ?
                  <div style={{ marginTop: 10 }}>
                  <Toggle
                      label={`The ${contactFormData?.userRole} can only view the dashboard content`}
                      value={contactFormData.isDashboardAccess}
                      onToggle={()=> onSetContactFormData({isDashboardAccess: !contactFormData.isDashboardAccess})}
                    />
                    </div>
                    :null}
                </Col>
            </Row>
          </>
            )}
          />
        );
      };
    }
    
const mapStateToProps = (state,ownProps) => {
  const contactFormData = selectContactFormData(state);
  return {
              contactFormData,
              suiteUsers:selectSuiteUsers(state),
            contacts: selectHomeOwners(state),
            allContacts:selectContacts(state),
            user: selectAuthenticatedUser(state),
            loader: selectFormLoader(state),
            validation: selectValidation(state),
          };
        };
        
const mapDispatchToProps = dispatch => bindActionCreators({
              onStopFormLoading: stopFormLoading,
            onSetContactFormData: setContactFormData,
            onSubmitContactForm: saveContact,
            setContactFormData,
            clearContactFormData: clearContactFormData,
            clearValidation: clearValidation
          }, dispatch);
          
          export default connect(mapStateToProps, mapDispatchToProps)(AddSuiteUser);
          
